import {PlacementType, SubsectionScreenPlacement, Section} from '@amzn/showtime';

import {getUri, getUriRegexString, CDSubsectionPlacementURI} from '../../utils/uriUtils/uriUtils';

const placement: SubsectionScreenPlacement = {
  id: CDSubsectionPlacementURI.id,
  title: 'Applications',
  type: PlacementType.SubsectionScreen,
  sectionId: Section.Job,
  initialUri: getUri(CDSubsectionPlacementURI),
  uri: getUriRegexString(CDSubsectionPlacementURI),
};

export default placement;
